<template>
    <div>
        <v-combobox
            :value="value"
            v-bind="$attrs"
            v-on="passedListeners"
            :items="suggestions"
            item-value="value"
            item-text="title"
            :filter="filterHandler"
            @input="handleChange"
            :loading="$attrs.loading || loadingSuggestion"
            v-if="allowManual"
            @keyup.enter.stop="handleEnterPress($event)"
        >
            <template v-slot:item="{ item }">
                <template v-if="item.header">
                    <v-list-item-content v-text="item" class="list-headers"></v-list-item-content>
                </template>

                <v-list-item-content v-else>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle> {{ item.description }}</v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-combobox>
        <v-autocomplete
            :value="value"
            v-bind="$attrs"
            :items="suggestions"
            item-value="value"
            item-text="title"
            :filter="filterHandler"
            @input="handleChange"
            :loading="$attrs.loading || loadingSuggestion"
            @keyup.enter.stop="handleEnterPress($event)"
            v-else
        >
            <template v-slot:item="{ item }">
                <template v-if="item.header">
                    <v-list-item-content v-text="item" class="list-headers"></v-list-item-content>
                </template>

                <v-list-item-content v-else>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle> {{ item.description }}</v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    name: 'ComboBox',
    props: {
        value: {
            required: false,
        },
        valStoreKey: {
            type: String,
            required: true,
        },
        allowManual: {
            type: Boolean,
            default: false,
        },
    },
    inheritAttrs: false,
    data: () => ({
        menuProps: {
            closeOnClick: true,
        },
        tempValHolder: null,
    }),
    methods: {
        handleChange(e) {
            const val = e?.value || e || null;
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    const values = val.map((x) => {
                        this.addValueToStore(x.value || x);
                        return x.value || x;
                    });
                    this.$emit('input', values);
                } else {
                    this.$emit('input', []);
                }
            } else {
                this.addValueToStore(val);
                this.$emit('input', val);
            }
        },
        blurHandler() {
            if (this.tempValHolder && this.tempValHolder.length > 0) {
                const vals = this.tempValHolder.map((x) => {
                    this.addValueToStore(x.value || x);
                    return x.value || x;
                });
                this.$emit('input', vals);
                this.tempValHolder = null;
            }
        },
        filterHandler(item, queryText) {
            if (queryText === '') {
                return true;
            }
            // eslint-disable-next-line no-unused-vars
            const { value, header, ...rest } = item;
            if (header) {
                return false;
            } else {
                return Object.values(rest).join('').toLowerCase().search(queryText.toLowerCase()) != -1;
            }
        },
        onlySpaces(str) {
            if (str) {
                return str.trim().length === 0;
            } else {
                return true;
            }
        },
        async addValueToStore(val) {
            if (!this.onlySpaces(val)) {
                this.$store.dispatch('valStore/setKeyValue', { valStoreKey: this.valStoreKey, value: val });
            }
        },
        getSuggestions(requestedKeyVal) {
            // Check if the val is undefined or null
            if (!requestedKeyVal) {
                return [];
            }
            const globals = requestedKeyVal?.global || [];
            const recents = requestedKeyVal?.recents || [];

            if (globals.length > 0 && recents.length > 0) {
                const userDataHeader = { header: 'Recents' };
                const globalDataHeader = { header: 'Others' };
                return [userDataHeader, ...recents, globalDataHeader, ...globals];
            }
            if (globals.length === 0 && recents.length > 0) {
                const userDataHeader = { header: 'Recents' };
                return [userDataHeader, ...recents];
            }
            if (recents.length === 0) {
                const globalDataHeader = { header: 'Values' };
                return [globalDataHeader, ...globals];
            }
        },

        handleEnterPress(event) {
            if (!this.$props.value) {
                this.handleChange(this.getRecentValue(this.suggestions));
            }
            console.log('===');
            this.$emit('enterPressed', event);
        },
        getRecentValue(array) {
            if (Array.isArray(array)) {
                if (array.length >= 2) {
                    return array.slice(0, 2).filter((x) => !x.header)[0].value || null;
                }
            } else {
                null;
            }
        },
    },
    computed: {
        suggestions() {
            return this.getSuggestions(this.$store.state.valStore.keyVals[this.$props.valStoreKey]);
        },
        loadingSuggestion() {
            return this.$store.state.valStore.loading;
        },
        passedListeners: function () {
            delete this.$listeners['input'];
            return this.$listeners;
        },
    },
};
</script>

<style scoped>
>>> .v-subheader {
    background: #e9e9e9;
}
</style>
